import React from 'react';
import { colors } from '../tokens';

// Minimal SVG sparkline. Renders a trend line + optional area fill.
const SparkLine = ({
  values = [],
  color = colors.brand,
  width = 72,
  height = 22,
  fill = true,
  strokeWidth = 1.5,
}) => {
  if (!values || values.length < 2) {
    return <svg width={width} height={height} />;
  }
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;
  const stepX = width / (values.length - 1);

  const pts = values.map((v, i) => {
    const x = i * stepX;
    const y = height - ((v - min) / range) * (height - 4) - 2;
    return [x, y];
  });

  const d = pts.map(([x, y], i) => `${i === 0 ? 'M' : 'L'}${x.toFixed(1)},${y.toFixed(1)}`).join(' ');
  const areaD = fill
    ? `${d} L${width},${height} L0,${height} Z`
    : null;

  return (
    <svg width={width} height={height} aria-hidden="true">
      {fill && <path d={areaD} fill={color} fillOpacity={0.12} />}
      <path d={d} fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default SparkLine;
